import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Navigate } from "react-router-dom";

export default class UpdateSocialMedia extends Component {
  state = {
    id: "",
    icon: null, // new file (if user selects)
    existing_icon: "", // existing icon path from backend
    url: "",
    message: "",
    notification: false,
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2]; // e.g. /updatesocialmedia/:id
    this.setState({ id });
    if (id) {
      this.getSingleSocialMedia(id);
    }
  }

  getSingleSocialMedia = async (id) => {
    try {
      if (init() !== "success") {
        return this.setState({ redirect: true });
      }

      // Adjust this URL according to your Constants
      // e.g. Constants.getUrls.getSocialMediaById
      const resp = await axios.get(`${Constants.getUrls.getSocialMedia}/${id}`);

      // assuming resp.data.data = { icon, url, ... }
      const data = resp.data?.data || {};

      this.setState({
        existing_icon: data.icon || "",
        url: data.url || "",
      });
    } catch (error) {
      console.error(error);
      this.setState({
        notification: true,
        message: "Error fetching social media details",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.url) {
      this.setState({
        notification: true,
        message: "Please enter a URL.",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
      return;
    }

    if (init() !== "success") {
      return this.setState({ redirect: true });
    }

    this.setState({ loading: true });

    const fd = new FormData();
    fd.append("url", this.state.url);

    // Only append file if a new one was selected
    if (this.state.icon instanceof File) {
      fd.append("icon", this.state.icon);
    }

    // Adjust this URL according to your Constants
    axios
      .put(`${Constants.putUrls.updateSocialMedia}/${this.state.id}`, fd)
      .then((resp) => {
        this.setState({
          notification: true,
          message:
            resp.data?.message || "Social media link updated successfully",
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "", redirect: true });
        }, 3000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message:
            err?.response?.data?.message || "Error updating social media link",
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 5000);
      });
  };

  render() {
    if (this.state.redirect === true) {
      // change '/socialmedia' to your listing route if different
      return <Navigate to="/socialmedia" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Social Media
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* Existing icon preview */}
                  {this.state.existing_icon && (
                    <Grid item sm={6} xs={12}>
                      <MDTypography variant="button" fontWeight="medium">
                        Current Icon
                      </MDTypography>
                      <MDBox mt={1}>
                        <img
                          src={Constants.imageDomain + this.state.existing_icon}
                          alt="Social Icon"
                          style={{
                            maxWidth: "80px",
                            maxHeight: "80px",
                            objectFit: "contain",
                          }}
                        />
                      </MDBox>
                    </Grid>
                  )}

                  {/* Upload new icon */}
                  <Grid item sm={6} xs={12}>
                    <TextField
                      type="file"
                      label="Upload New Icon (optional)"
                      name="icon"
                      fullWidth
                      focused
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({
                          icon: e.target.files[0] || null,
                        })
                      }
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Grid>

                  {/* URL field */}
                  <Grid item sm={12} xs={12}>
                    <TextField
                      type="url"
                      label="Social Media URL"
                      name="url"
                      fullWidth
                      required
                      value={this.state.url}
                      onChange={this.handleInput}
                      placeholder="https://facebook.com/yourpage"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton
                    variant="contained"
                    size="small"
                    color="info"
                    type="submit"
                  >
                    {this.state.loading ? "Updating..." : "Update"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="Fabinov8 | Social Media"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
